import React, { useEffect, useMemo } from "react";
import { unsubscribeAll } from "services";
export const useSubs = (): any[] => {
	const subs: any[] = useMemo(() => [], []);
	useEffect(() => {
		return () => unsubscribeAll(subs)()
	}, [subs]);
	return subs;
};
